module.exports = __webpack_public_path__ + "images/questions/qa_human_03_9ff59c7ece46dd0cec205cea463431c3.png";